<app-breadcrumb [styleBreadcrumb]="'page-heading'" [title]="'CODE-SETS'" [breadcrumb]="''" [count]="codeSetCount"
  icon="fa-books">
</app-breadcrumb>
<div class="content-background">
  <div class="row">
    <div class="col-sm-12">
      <div class="inputWithIcon inputWithIcon-search float-right d-flex">
        <app-advanced-mode id="codeSetGridAdvanced" [storageKey]="'codesets-list'"
          (collapsibleToggle)="codeSetGridAdvanced=$event">
        </app-advanced-mode>
        <input #search kendoTextBox class="ml-4 button-search" placeholder="{{ 'SEARCH-NAME' | translate }}"
          (keyup)="searchFieldChange(search.value)" title="{{ 'SEARCH-NAME' | translate }}" />
        <i class="fa fa-search fa-lg fa-fw fa-search-icon"></i>
      </div>
    </div>
  </div>
  <div class="mt-3 clearfix">
    <!-- data grid for code set -->
    <kendo-grid [data]="codeSetGrid.gridData" [loading]="codeSetGrid.loading" [navigable]="true"
      [pageable]="codeSetCount > codeSetGrid.state.take ? { buttonCount: 5, pageSizes: pageSizes} : false"
      [skip]="codeSetGrid.state.skip" [pageSize]="codeSetGrid.state.take" [sortable]="true"
      [sort]="codeSetGrid.state.sort" [filterable]="codeSetGridAdvanced" [filter]="codeSetGrid.state.filter"
      [selectable]="{mode: 'single'}" [columnMenu]="codeSetGridAdvanced" [resizable]="true"
      [reorderable]="codeSetGridAdvanced" (dataStateChange)="codeSetGrid.setState($event); selectedCodeSet = null;"
      [kendoGridSelectBy]="'id'" (selectedKeysChange)="onSelectedKeysChange($event)" (add)="codeSetAddHandler($event)"
      (edit)="codeSetEditHandler($event)" (save)="saveCodeSet($event)" (cancel)="codeSetGrid.cancelHandler($event)">
      <kendo-grid-messages noRecords="{{ 'NO-CODESETS' | translate }}">
      </kendo-grid-messages>
      <kendo-grid-column field="name" title="{{'NAME' | translate}}" [width]="60"></kendo-grid-column>
      <kendo-grid-column field="description" title="{{'DESCRIPTION' | translate}}" [width]="120"></kendo-grid-column>
      <kendo-grid-command-column [width]="20" title="{{ 'ACTIONS' | translate }}" class="text-center">
        <ng-template kendoGridCellTemplate let-dataItem let-isNew="isNew">
          <ng-container *ngIf="!dataItem.editing">
            <i class="fas fa-edit fa-lg" title="{{'EDIT' | translate}}"
              (click)="codeSetEditButton.click.emit($event); dataItem.editing = true;"></i>
            &nbsp;
            <i class="fas fa-trash-alt fa-lg" title="{{'DELETE' | translate}}"
              (click)="openDeleteCodeSetDialog(dataItem)"></i>
            <button kendoGridEditCommand #codeSetEditButton class="d-none"></button>
          </ng-container>
          <ng-container *ngIf="dataItem.editing">
            <ng-container *ngIf="codeSetFormGroup.valid">
              <i class="fas fa-check fa-lg icon-success pointer" title="{{'SAVE' | translate}}"
                (click)="codeSetSaveButton.click.emit($event); dataItem.editing = false;">
              </i>
              &nbsp;
            </ng-container>
            <i class="fas fa-times-circle fa-lg icon-neutral pointer" title="{{'CANCEL' | translate}}"
              (click)="codeSetCancelButton.click.emit($event); dataItem.editing = false;"></i>
            <button kendoGridSaveCommand #codeSetSaveButton class="d-none"></button>
            <button kendoGridCancelCommand #codeSetCancelButton class="d-none"></button>
          </ng-container>
        </ng-template>
      </kendo-grid-command-column>
      <button kendoGridAddCommand #codeSetAddButton class="d-none"></button>
    </kendo-grid>
    <button kendoButton type="button" class="float-right mt-3 mb-3" (click)="codeSetAddButton.click.emit($event);">
      {{'NEW-CODESET' | translate}}<i class="far fa-plus"></i>
    </button>
  </div>
  <br>
  <div *ngIf="selectedCodeSet">
    <hr>
    <h2>{{'CODES' | translate}}</h2>
    <div class="row">
      <div class="col-sm-6"></div>
      <div class="col-sm-6">
        <div class="float-right">
          <app-advanced-mode id="codeGridAdvancedSwitch" [storageKey]="'codes-list'"
            (collapsibleToggle)="codeGridAdvanced=$event">
          </app-advanced-mode>
        </div>
      </div>
    </div>
    <div class="mt-3 clearfix">
      <!-- data grid for codes -->
      <kendo-grid #grid [data]="codeGrid.gridData" [loading]="codeGrid.loading" [navigable]="true"
        [pageable]="codeCount > codeGrid.state.take ? { buttonCount: 5, pageSizes: pageSizes} : false"
        [skip]="codeGrid.state.skip" [pageSize]="codeGrid.state.take" [sortable]="true" [sort]="codeGrid.state.sort"
        [filterable]="codeGridAdvanced" [filter]="codeGrid.state.filter" (dataStateChange)="codeGrid.setState($event)"
        [selectable]="{mode: 'single'}" [kendoGridSelectBy]="'id'" [columnMenu]="codeGridAdvanced" [resizable]="true"
        [reorderable]="codeGridAdvanced" (add)="codeAddHandler($event)" (edit)="codeEditHandler($event)"
        (save)="saveCode($event)" (cancel)="codeGrid.cancelHandler($event)">
        <kendo-grid-messages noRecords="{{ 'NO-CODES' | translate }}">
        </kendo-grid-messages>
        <kendo-grid-column field="codeSystem" title="{{'CODE-SYSTEM' | translate}}" [width]="20"></kendo-grid-column>
        <kendo-grid-column field="sourceCodeSystem" title="{{'SOURCE-CODE-SYSTEM' | translate}}"
          [width]="20"></kendo-grid-column>
        <kendo-grid-column field="code" title="{{'CODE' | translate}}" [width]="20"></kendo-grid-column>
        <kendo-grid-column field="alternateCode" title="{{'ALTERNATE-CODE' | translate}}" [width]="20">
        </kendo-grid-column>
        <kendo-grid-column field="displayName" title="{{'DISPLAY-NAME' | translate}}" [width]="30"></kendo-grid-column>
        <kendo-grid-column field="icon" title="{{'ICON' | translate}}" [width]="20"></kendo-grid-column>
        <kendo-grid-column field="codeSetPerRecord" title="{{'CODE-SET' | translate}}" [width]="20"
          *ngIf="selectedCodeSet.id === flagCategoryCodesetId">
          <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="codeFormGroup">
            <kendo-dropdownlist [defaultItem]="{ id: null, name: '' }" [data]="codeSets" textField="name"
              valueField="id" [valuePrimitive]="false" [formControl]="codeFormGroup.get('codeSetPerRecord')">
            </kendo-dropdownlist>
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem>
            <span *ngIf="dataItem.codeSetPerRecord">{{dataItem.codeSetPerRecord.name}}</span>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-command-column [width]="10" title="{{ 'ACTIONS' | translate }}" class="text-center">
          <ng-template kendoGridCellTemplate let-dataItem>
            <ng-container *ngIf="!dataItem.editing">
              <i class="fas fa-edit fa-lg" title="{{'EDIT' | translate}}"
                (click)="codeEditButton.click.emit($event); dataItem.editing = true;"></i>
              &nbsp;
              <i class="fas fa-trash-alt fa-lg" title="{{'DELETE' | translate}}"
                (click)="openDeleteCodeDialog(dataItem)"></i>
              <button kendoGridEditCommand #codeEditButton class="d-none"></button>
            </ng-container>
            <ng-container *ngIf="dataItem.editing">
              <ng-container *ngIf="codeFormGroup.valid">
                <i class="fas fa-check fa-lg icon-success pointer" title="{{'SAVE' | translate}}"
                  (click)="codeSaveButton.click.emit($event); dataItem.editing = false;">
                </i>
                &nbsp;
              </ng-container>
              <i class="fas fa-times-circle fa-lg icon-neutral pointer" title="{{'CANCEL' | translate}}"
                (click)="codeCancelButton.click.emit($event); dataItem.editing = false;"></i>
              <button kendoGridSaveCommand #codeSaveButton class="d-none"></button>
              <button kendoGridCancelCommand #codeCancelButton class="d-none"></button>
            </ng-container>
          </ng-template>
        </kendo-grid-command-column>
        <button kendoGridAddCommand #codeAddButton class="d-none"></button>
        <!--Code languages support-->
        <ng-template *ngIf="isShowMultipleCodeLanguages()" kendoGridDetailTemplate let-dataItem>
          <div class="w-75">
            <app-codeset-language-edit [dataItem]="dataItem" [codeGridAdvanced]="codeGridAdvanced">
            </app-codeset-language-edit>
          </div>
        </ng-template>
      </kendo-grid>
      <div class="float-right mt-3 mb-3">
        <input type="file" id="csvFile" #csvFileInput accept=".csv, text/plain" class="d-none"
          (change)="handleCsvInput($event.target.files)" />
        <button kendoButton type="button" title="{{'EXPORT-CODE-SET-TO-CSV' | translate}}"
          (click)="exportCodeSetToCsv()">{{'EXPORT' | translate}}<i class="far fa-file-export"></i>
        </button>
        &nbsp;&nbsp;
        <button kendoButton type="button" title="{{'IMPORT-CODES-FROM-CSV' | translate}}"
          (click)="csvFileInput.click();">{{'IMPORT' | translate}}<i class="far fa-file-import"></i>
        </button>
        &nbsp;&nbsp;
        <button kendoButton type="button" (click)="codeAddButton.click.emit($event);">
          {{'ADD' | translate}}<i class="far fa-plus"></i>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- delete code set confirmation dialog -->
<kendo-dialog *ngIf="codeSetDeleteDialogOpened" title="{{'PLEASE-CONFIRM' | translate}}" [width]="400"
  (close)="codeSetDeleteDialogOpened = false">
  <p>{{'CONFIRM-CODESET-DELETION' | translate}}</p>
  <div>
    <span class="k-font-weight-bold">{{selectedCodeSet.name}}&nbsp;-&nbsp;{{selectedCodeSet.description}}</span>
  </div>
  <div *ngIf="errorMessage" class="text-danger k-tooltip-validation" role="alert">
    {{errorMessage}}
  </div>
  <kendo-dialog-actions>
    <button kendoButton (click)="codeSetDeleteDialogOpened = false">{{'NO' | translate}}</button>
    <button kendoButton (click)="deleteCodeSet(selectedCodeSet)" [disabled]="errorMessage">{{'YES' |
      translate}}</button>
  </kendo-dialog-actions>
</kendo-dialog>

<!-- delete code confirmation dialog -->
<kendo-dialog *ngIf="codeDeleteDialogOpened" title="{{'PLEASE-CONFIRM' | translate}}" [width]="400"
  (close)="codeDeleteDialogOpened = false">
  <p>{{'CONFIRM-CODE-DELETION' | translate}}</p>
  <div>
    <span class="k-font-weight-bold">{{selectedCode.code}}&nbsp;-&nbsp;{{selectedCode.displayName}}</span>
  </div>
  <div *ngIf="errorMessage" class="text-danger k-tooltip-validation" role="alert">
    {{errorMessage}}
  </div>
  <kendo-dialog-actions>
    <button kendoButton (click)="codeDeleteDialogOpened = false">{{'NO' | translate}}</button>
    <button kendoButton (click)="deleteCode(selectedCode)" [disabled]="errorMessage">{{'YES' | translate}}</button>
  </kendo-dialog-actions>
</kendo-dialog>